import React from "react";
import { SelectFilter } from "./select-filter/select-filter.component";
import type { FilterComponentProps } from "../types";

type BoolFilterProps = FilterComponentProps<{
  trueLabel?: string;
  falseLabel?: string;
}>;

export function BoolFilter({
  columnSchema,
  onClose,
  filterControl,
  trueLabel,
  falseLabel,
}: BoolFilterProps) {
  return (
    <SelectFilter
      columnSchema={columnSchema}
      onClose={onClose}
      filterControl={filterControl}
      getSelectionOptions={() => {
        return [
          { id: "true", name: trueLabel || "True" },
          { id: "false", name: falseLabel || "False" },
        ];
      }}
      isBool
    />
  );
}
